import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

const PayPalButton = ({ amount }) => {
    const [paidFor, setPaidFor] = useState(false);
    const [error, setError] = useState(null);

    const handleApprove = (orderID) => {
        // Do something with the approved order
        setPaidFor(true);
        // console.log("Order approved! ID:", orderID);
    };

    if (paidFor) {
        return <h1>Thank you for your purchase!</h1>;
    }

    if (error) {
        return <h1>Error processing the payment: {error}</h1>;
    }

    return (
        <PayPalScriptProvider options={{ "client-id": "AVQJvtHw8tXqSJVJphhrbZqA1AlDU2HBavK6PiJeMCXArCDxNyU7_jVKVNyOkTl5QHGMsbDHt_hVFdbV" }}>
            <PayPalButtons
                style={{ layout: "vertical" }}
                createOrder={(data, actions) => {
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                                value: amount, // Replace this with the dynamic amount
                            },
                        }],
                    });
                }}
                onApprove={(data, actions) => {
                    return actions.order.capture().then((details) => {
                        handleApprove(details.id);
                    });
                }}
                onError={(err) => {
                    setError(err);
                    console.error("PayPal Checkout error:", err);
                }}
            />
        </PayPalScriptProvider>
    );
};

export default PayPalButton;
